import { render, staticRenderFns } from "./payment-methods.vue?vue&type=template&id=6c91f300&scoped=true"
import script from "./payment-methods.vue?vue&type=script&lang=js"
export * from "./payment-methods.vue?vue&type=script&lang=js"
import style0 from "./payment-methods.vue?vue&type=style&index=0&id=6c91f300&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c91f300",
  null
  
)

export default component.exports